import { JsonProperty, Serializable } from "typescript-json-serializer";
export interface IObjectTreeService {

    catalogs: Array<Icatalog>;
    // 当前分类
    currentCatalog: Icatalog;
    // 当前页码下的类目产品
    products: Array<any>;
    // 页码
    currentPage: number;
    // 排序类型
    sortType: string;
    // 过滤条件
    // filter: string;
    // 产品总数量
    totalCount: number;
    // 用于分类页移动端,固定类目名称所在区域
    productsHeaderFixed: boolean;
    // url参数（店铺id（个人中心--》店铺产品列表--》添加店铺产品））
    urlParameter: string;
    // 产品类目映射数据
    catalogsMap: IcatalogsMap;

    getMore(sortType: string, filter?: string): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.product.model.dto.catalog.ICatalogProductList>>;

    refresh(catalogPath: string, sortType: string, filter?: string): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.product.model.dto.catalog.ICatalogProductList>>;

}
export interface IPageRootScope extends angular.IScope {
    catalogs: Array<any>;
    catalogCtrl: ICatalogScope;
}
export interface ICatalogScope extends IPageRootScope {

}
export interface Icatalog {
    id: number;
    name: string;
    pageName: string;
    catalogPath: string;
    parentId?: number;
    isopenNew?: boolean;
    // catalogType:string;
    catalogSign?: string;
    pageTitle: string;
    metaDescription: string;
    metaRobots: string;

}

@Serializable()
export class Catalog {
    @JsonProperty()
    id: number;
    @JsonProperty()
    name: string;
    @JsonProperty()
    pageName: string;
    @JsonProperty()
    catalogPath: string;
    @JsonProperty()
    parentId?: number;
    @JsonProperty()
    isopenNew?: boolean;
    // catalogType:string;
    @JsonProperty()
    catalogSign?: string;
    @JsonProperty()
    pageTitle: string;
    @JsonProperty()
    metaDescription: string;
    @JsonProperty()
    metaRobots: string;

}

export interface IbreadcrumbCatalog {
    id: number;
    name: string;
    pagePath: string;
}
export interface IcatalogsMap {
    (id: string): IcatalogMap
}
export interface IcatalogMap {
    id: number;
    name: string;
    pageName: string;
    catalogPath: string;
    parentId?: number;
    catalogSign?: string;
}
export interface IConstCatalog {
    catalogPath: string;
    id: number;
    name: string;
    pageName: string;
    // catalogType:string;
}
@Serializable()
export class ConstCatalog {
    @JsonProperty()
    catalogPath: string;
    @JsonProperty()
    id: number;
    @JsonProperty()
    name: string;
    @JsonProperty()
    pageName: string;
    // catalogType:string;
}


export interface ICatalogPagePathMapItem {
    catalogPagePath: string;
    id: number;
    name: string;
    pageName: string;
    catalogPath: string;
    parentId?: number;
    isopenNew?: boolean;
    // catalogType:string;
    catalogSign?: string;
    pageTitle: string;
    metaDescription: string;
    metaRobots: string;
}